export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8791.de8b492d.jpg";